import React, { useState , useEffect } from 'react'
import CommonSEOTitle from '../../../../helpers/CommonSEOTitle'
import AccountNavigation from '../Navigation/AccountNavigation'
import { Col, FormLabel, Row } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { useGetProfile } from '@hooks';
import { onDefaultError } from '../../../../helpers/commonHelpers'

const AddressDetailsPage = ({ t }) => {
    const navigate = useNavigate();
    const [data, setData] = useState({});

    const { refetch, isLoading } = useGetProfile(
        ({ data: profile }) => {
            if (profile) {
                setData(profile);
            }
        },
        (error) => {
            onDefaultError(error);
        }
    );

    useEffect(() => {
        if(data?.user_type && data?.user_type != 2){
            navigate(`/my-profile`);
        }
    },[data]);


    return (
        <>

            {data && Object.keys(data).length > 0 ? (

                <>
                    <CommonSEOTitle title={t('page.address_details')} />
                    {/* Navigation */}
                    <AccountNavigation t={t} formatted_joining_date={data?.formatted_joining_date} formatted_last_working_date={data?.formatted_last_working_date} data={data} />

                    <div className='px-4 mt-4'>
                        <h2 className='sub-title'>{t('page.view_user_current_address')}</h2>
                        <Row>
                            {/* Current Address 01 */}
                            <Col md={6} xs={12} className='mb-3 mb-md-4'>
                                <FormLabel className='control-label'>
                                    {t('page.current_addres_01')}
                                </FormLabel>
                                <div className='user-info-value'>
                                    {data?.address_info?.current?.address1}
                                </div>
                            </Col>

                            {/* Current Address 02 */}
                            <Col md={6} xs={12} className='mb-3 mb-md-4'>
                                <FormLabel className='control-label'>
                                    {t('page.current_addres_02')}
                                </FormLabel>
                                <div className='user-info-value'>
                                    {data?.address_info?.current?.address2}
                                </div>
                            </Col>
                        </Row>

                        <Row>
                            {/* Current Zip Code */}
                            <Col lg={3} md={6} xs={12} className='mb-3 mb-md-4'>
                                <FormLabel className='control-label'>
                                    {t('page.view_user_zipcode')}
                                </FormLabel>
                                <div className='user-info-value'>
                                    {data?.address_info?.current?.zipcode}
                                </div>
                            </Col>

                            {/* Current City */}
                            <Col lg={3} md={6} xs={12} className='mb-3 mb-md-4'>
                                <FormLabel className='control-label'>
                                    {t('page.view_user_city')}
                                </FormLabel>
                                <div className='user-info-value'>
                                    {data?.address_info?.current?.city}
                                </div>
                            </Col>

                            {/* Current State */}
                            <Col lg={3} md={6} xs={12} className='mb-3 mb-md-4'>
                                <FormLabel className='control-label'>
                                    {t('page.view_user_state')}
                                </FormLabel>
                                <div className='user-info-value'>
                                    {data?.address_info?.current?.state}
                                </div>
                            </Col>

                            {/* Current Country */}
                            <Col lg={3} md={6} xs={12} className='mb-3 mb-md-4'>
                                <FormLabel className='control-label'>
                                    {t('page.country_label')}
                                </FormLabel>
                                <div className='user-info-value'>
                                    {data?.address_info?.current?.address_country_name}
                                </div>
                            </Col>
                        </Row>

                        <h2 className="sub-title">{t('page.distance_from_current_address')}</h2>
                        <Row>
                        <Col lg={3} md={6} xs={12} className='mb-3 mb-md-4'>
                            <div className="user-info-value">
                                {data?.address_info?.current?.distance}
                            </div>
                        </Col>
                        </Row>

                        {(data?.address_info?.current?.is_permanent_same != '' && data?.address_info?.current?.is_permanent_same != null) && (
                            <h2 className='sub-title'>{t('page.view_user_permanent_address')}</h2>
                        )}
                        {data?.address_info?.current?.is_permanent_same == 1 && (
                            <div className='user-info-value'>Same as Current Address.</div>
                        )}

                        {data?.address_info?.current?.is_permanent_same == 2 ? (
                            <>
                                <Row>
                                    {/* Permanent Address 01 */}
                                    <Col md={6} xs={12} className='mb-3 mb-md-4'>
                                        <FormLabel className='control-label'>
                                            {t('page.permanent_address_01')}
                                        </FormLabel>
                                        <div className='user-info-value'>
                                            {data?.address_info?.permanent?.address1}
                                        </div>
                                    </Col>

                                    {/* Permanent Address 02 */}
                                    <Col md={6} xs={12} className='mb-3 mb-md-4'>
                                        <FormLabel className='control-label'>
                                            {t('page.permanent_address_02')}
                                        </FormLabel>
                                        <div className='user-info-value'>
                                            {data?.address_info?.permanent?.address2}
                                        </div>
                                    </Col>
                                </Row>

                                <Row>
                                    {/* Permanent Zip Code */}
                                    <Col lg={3} md={6} xs={12} className='mb-3 mb-md-4'>
                                        <FormLabel className='control-label'>
                                            {t('page.permanent_zip_code')}
                                        </FormLabel>
                                        <div className='user-info-value'>
                                            {data?.address_info?.permanent?.zipcode}
                                        </div>
                                    </Col>

                                    {/* Permanent City */}
                                    <Col lg={3} md={6} xs={12} className='mb-3 mb-md-4'>
                                        <FormLabel className='control-label'>
                                            {t('page.permanent_city')}
                                        </FormLabel>
                                        <div className='user-info-value'>
                                            {data?.address_info?.permanent?.city}
                                        </div>
                                    </Col>

                                    {/* Permanent State */}
                                    <Col lg={3} md={6} xs={12} className='mb-3 mb-md-4'>
                                        <FormLabel className='control-label'>
                                            {t('page.permanent_state')}
                                        </FormLabel>
                                        <div className='user-info-value'>
                                            {data?.address_info?.permanent?.state}
                                        </div>
                                    </Col>

                                    {/* Permanent Country */}
                                    <Col lg={3} md={6} xs={12} className='mb-3 mb-md-4'>
                                        <FormLabel className='control-label'>
                                            {t('page.view_user_per_country_name')}
                                        </FormLabel>
                                        <div className='user-info-value'>
                                            {data?.address_info?.permanent?.address_country_name}
                                        </div>
                                    </Col>
                                </Row>
                            </>
                        ) : null}

                    </div>
                </>) : null}
        </>
    )
}

export default AddressDetailsPage
